import React from 'react'
import ReactDOM from 'react-dom'
import './index.css';
import App from './components/App'
import './fonts/digital-7.ttf'

ReactDOM.render(<App />, document.getElementById('root'))